import type { Message, RealtimeChannel } from "ably";
import type { LastMessagePollingConfig } from "../core";
import type { DirectHistoryFetcher } from "../vision/directHistory";
import { useLastMessage } from "./useLastMessage";

export function useLastMessageAction<TMessage extends Message = Message>(
	ablyChannel: RealtimeChannel | null,
	onLastMessage: (msg: TMessage) => void,
	pollingConfig?: LastMessagePollingConfig | null,
	directFetcher?: DirectHistoryFetcher | null,
) {
	useLastMessage(ablyChannel, onLastMessage as (msg: Message) => void, pollingConfig, directFetcher);
}
